module.exports = __webpack_public_path__ + "static/media/view-support-card@2x.896143ac.jpg";